import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Context } from "../../../_context/Store";
import { contextApiActions } from "../../../_redux/_constants";

export function UiFullLoadingSpinner(props) {
    const loader = useSelector((state) => state.loading);
    const [state, dispatch] = useContext(Context);
    const location = useLocation();

    useEffect(() => {
        if (location.pathname != "/") {
            dispatch({
                type: contextApiActions.SET_REQUESTED_URL,
                payload: location.pathname,
            });
        }
    }, []);

    return (
        <>
            {loader.show && (
                <div className="sb-loading-wr">
                    <div className="loader"></div>
                </div>
            )}
        </>
    );
}

export function SuspenseLoading(props) {
    return (
        <div className="sb-loading-text-wr">
            <div className="sb-loading-text-wr__loader-text">Loading...</div>
        </div>
    );
}

export function UiVoucherLoading(props) {
    // const voucherLoader = useSelector((state) => state.loading);

    return (
        <>
            {props.voucherLoader && (
                <div className="sb-loading-wr-voucher">
                    <div className="sb-voucher-loader-content">
                        <div className="loader"></div>
                        <h3>
                            We're preparing <br />
                            your voucher
                        </h3>
                        <h5>Please wait a few more seconds</h5>
                    </div>
                </div>
            )}
        </>
    );
}

export function UiChatBotLoadingSpinner(props) {
    return (
        <>
            {props.chatLoader && (
                <div className="sb-loading-wr-chat">
                    <div className="loader"></div>
                </div>
            )}
        </>
    );
}
